'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002epages$002esigning$002e$002dSigning$002dApi$0024$0024anon$00242 from "./presto.pages.signing.-Signing-Api$$anon$2.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_signing_SigningApi$$anon$1(outer) {
  this.bWC = null;
  this.bWA = null;
  this.bWB = false;
  this.bWy = null;
  this.bWz = false;
  this.bWD = false;
  this.bWE = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bWC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_signing_SigningApi$$anon$1 as $c_Lpresto_pages_signing_SigningApi$$anon$1 };
$p = $c_Lpresto_pages_signing_SigningApi$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_signing_SigningApi$$anon$1;
/** @constructor */
function $h_Lpresto_pages_signing_SigningApi$$anon$1() {
}
export { $h_Lpresto_pages_signing_SigningApi$$anon$1 as $h_Lpresto_pages_signing_SigningApi$$anon$1 };
$h_Lpresto_pages_signing_SigningApi$$anon$1.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bWC;
});
$p.t = (function() {
  if ((!this.bWB)) {
    this.bWA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("cpf", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("rubric", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("location", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bWB = true;
  }
  return this.bWA;
});
$p.ae = (function() {
  if ((!this.bWz)) {
    this.bWy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002epages$002esigning$002e$002dSigning$002dApi$0024$0024anon$00242.$c_Lpresto_pages_signing_SigningApi$$anon$2(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bWz = true;
  }
  return this.bWy;
});
$p.w = (function() {
  if ((!this.bWE)) {
    this.bWD = false;
    this.bWE = true;
  }
  return this.bWD;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_signing_SigningApi$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_signing_SigningApi$$anon$1, "presto.pages.signing.SigningApi$$anon$1", ({
  Xd: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_signing_SigningApi$$anon$1 as $d_Lpresto_pages_signing_SigningApi$$anon$1 };
//# sourceMappingURL=presto.pages.signing.-Signing-Api$$anon$1.js.map
